export const CC_PORTAL = '/credit-cards';
export const DEFAULT = '';
